module.exports = __webpack_public_path__ + "img/conclusion4.d5b609a8.svg";